import { MutationTuple, useMutation } from '@apollo/client';
import { UpdateRodRequestInput, UpdateRodRequestPayload } from '@bechtel/types';
import { UPDATE_ROD_REQUEST } from '@bechtel/client-gql';

export function useUpdateRodRequest(
  onActionCompleted?: () => void
): MutationTuple<{ updateRodRequest: UpdateRodRequestPayload }, { input: UpdateRodRequestInput }> {
  const response = useMutation<{ updateRodRequest: UpdateRodRequestPayload }, { input: UpdateRodRequestInput }>(
    UPDATE_ROD_REQUEST,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: () => {
        if (onActionCompleted) onActionCompleted();
      },
      onError: () => {
        if (onActionCompleted) onActionCompleted();
      },
    }
  );
  return response;
}
